import { forwardRef } from 'react';

import type { IconProps } from './types';

/*
 * DO NOT remove `forwardRef`
 * It is used for `motion.create`
 */
const MotiHappy = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg width="24" height="24" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" {...props} ref={forwardedRef}>
    <path
      d="M512 0C231.394 0 3.972 229.23 3.972 512c0 116.428 38.55 223.783 103.503 309.792l-29.02 99.366c-9.44 32.35 20.377 62.421 52.469 52.911l106.096-31.503C316.281 994.082 410.661 1024 511.999 1024c280.573 0 508.028-229.232 508.028-512S792.573 0 511.999 0zm1.049 144.496c227.195 0 411.421 127.827 411.421 356.468 0 228.644-184.225 223.558-411.421 223.558-227.223 0-411.421 5.086-411.421-223.558 0-228.641 184.197-356.468 411.421-356.468zm5.186 69.132c-187.619 0-339.751 99.17-339.751 276.635 0 177.466 152.132 173.572 339.751 173.572s339.697 3.895 339.697-173.572c0-177.464-152.077-276.635-339.697-276.635zM377.931 393.711c43.618 0 79.007 35.572 79.007 79.504s-35.388-2.537-79.007-2.537c-43.615 0-78.896 46.469-78.896 2.537s35.281-79.504 78.896-79.504zm280.552 0c43.615 0 78.952 35.572 78.952 79.504s-35.337-2.537-78.952-2.537c-43.618 0-78.952 46.469-78.952 2.537s35.334-79.504 78.952-79.504z"
      fill={color}
    />
  </svg>
));

export default MotiHappy;
